import { Controller } from "stimulus";

export default class extends Controller {
  toggle(evt: Event) {
    evt.preventDefault();
    this.element.classList.toggle("expanded");
  }
}
